import { nhost } from 'utility'
import { gql } from 'graphql-request'
const approverStatus = ['For Approval', 'Published', 'Rejected at Approval', 'For Review (Require Amending)', 'For Second Approval']
export const getNotifications = async () => {
  let QUERY = gql`
    subscription getNotifications {
      notifications {
        id
        title
        source_name
        created_at
        updated_at
        sender
        recepient
        is_open
        is_read
        description
      }
    }
  `
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const getUser = async (userId: string) => {
  let QUERY = gql`query getUser {
  user(id: "${userId}") {
  id
  displayName
  email
  defaultRole
  createdAt
  updatedAt
}

}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const getAllNotifications = async () => {
  let QUERY = gql`
    query getAllNotifications {
      notifications {
        id
        title
        source_name
        created_at
        updated_at
        sender
        recepient
        is_open
        is_read
        description
      }
    }
  `
  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const getWorkRequestByConditions = async (condition: any) => {
  let QUERY = gql`query getWorkRequestByConditions {
    work_requests(where:{active:{_eq:true},${condition}}, order_by: {created_at: desc}){
      id,
    name,
    count,
    request_type,
    grade_id,
   grade{
    name
  },
    topic_id,
    topic{
    name
  },
  subject_id,
  subject{
    name
  },
    theme_id,
    theme{
      name
    },
    sub_theme_id,
     sub_theme {name},
    report_theme_id,
    report_theme{name},
    question_type_id,
    question_type{name},
    teacher_level_id,
    teacher_level {name},
    bloom_level_id,
    bloom_level{name },
    difficulty_level_id,
    difficulty_levels{name},
    centa_standard_id,
    centa_standard{name },
    strand_id,
    competency_id,
    competencies{name},
    request_id,
    description,
    variant_options,
    status,
    grade_ids,
    due_date,
    created_at,
    questions,
    questions{title,status},
    creator_id,
    userByCreatorId{displayName },
    reviewer_ids,
    approver_ids,
    completion_status,
    workRequestGrades{
      grade{
        name
        id
      }
    }
    workRequestReviewers{
      user_id,
    id,
    userByReviewerId{
      id
      displayName
    }
  },
  workRequestApprovers{
    id,
    approver_id,
    userByApprover{
      id
      displayName
    },
    userByReviewerId{
      id,
      displayName
    }
  },
  
    #  workRequestReviewers{id,user_id, { userByReviewerId{displayName,id } }},
    # workRequestApprovers {id,approver_id, { userByApprover{displayName, id'}}, reviewer_id,userByReviewerId{displayName, id}}

}}`

  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const getAllWorkRequest = async (filter: any, limit: number, offset: number, sort_by: string, sort_order: string) => {
  let QUERY = gql`query getAllWorkRequest {
    work_requests(where:{active:{_eq:true},${filter}}, order_by: {${sort_by}: ${sort_order}},limit:${limit},offset:${offset}){
      id,
    name,
    count,
    request_type,
    grade_id,
   grade{
    name
  },
    topic_id,
    topic{
    name
  },
  subject_id,
  subject{
    name
  },
    theme_id,
    theme{
      name
    },
    sub_theme_id,
     sub_theme {name},
    report_theme_id,
    report_theme{name},
    question_type_id,
    question_type{name},
    teacher_level_id,
    teacher_level {name},
    bloom_level_id,
    bloom_level{name },
    difficulty_level_id,
    difficulty_levels{name},
    centa_standard_id,
    centa_standard{name },
    strand_id,
    competency_id,
    competencies{name},
    request_id,
    description,
    variant_options,
    status,
    grade_ids,
    due_date,
    created_at,
    questions,
    questions{title,status},
    creator_id,
    userByCreatorId{displayName },
    reviewer_ids,
    approver_ids,
    completion_status,
    workRequestGrades{
      grade{
        name
        id
      }
    }
    workRequestReviewers{
      user_id,
    id,
    userByReviewerId{
      id
      displayName
    }
  },
  workRequestApprovers{
    id,
    approver_id,
    userByApprover{
      id
      displayName
    },
    userByReviewerId{
      id,
      displayName
    }
  },
 
  
    
      },
       work_requests_aggregate(where:{active:{_eq:true},${filter}}){
    aggregate{
      count
    }
  }
    }
  `

  const { data } = await nhost.graphql.request(QUERY)

  return data
}
export const getAllThemes = async () => {
  let QUERY = gql`
    query getAllThemes {
      themes(order_by: { created_at: desc }) {
        id
        name
        subject_id
        subject {
          name
        }
      }
    }
  `
  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const getWorkRequestCount = async (condition: any) => {
  let QUERY = gql`
    query getWorkRequestCount {
      work_requests_aggregate(where:{active:{_eq:true},${condition}}) {
        aggregate{
      count
    }
      }
    }
  `
  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const getQuestionCount = async (condition: any) => {
  let QUERY = gql`
    query  {
      questions_aggregate(where:{${condition}}) {
        aggregate{
      count
    }
      }
    }
  `
  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const getThemeData = async () => {
  let QUERY = `query getThemeData {
  themes {
    id,
    name,
    subject_id,
    report_theme_id,
    report_theme{
      name
    },
    subject{
      name
    },
    created_at,
  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

const generateAggQuery = (resource: string) => gql`
  query getRequestAgg($where: ${resource}_bool_exp) {
    ${resource}_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`

export const getPaperRequestCount = async (condition: any) => {
  let QUERY = gql`
    query getRequestAgg($where: paper_requests_bool_exp) {
      paper_requests_aggregate(where: $where) {
        aggregate {
          count
        }
      }
    }
  `
  const { data } = await nhost.graphql.request(QUERY, { where: condition })
  return data
}
export const getPaperCount = async (condition: any) => {
  const QUERY = gql`
    query getPaperAgg($where: papers_bool_exp) {
      papers_aggregate(where: $where) {
        aggregate {
          count
        }
      }
    }
  `
  const { data } = await nhost.graphql.request(QUERY, { where: condition })
  return data
}
export const getPaperTemplateCount = async (condition: any) => {
  const QUERY = gql`
    query getPaperTemplateAgg($where: paper_templates_bool_exp) {
      paper_templates_aggregate(where: $where) {
        aggregate {
          count
        }
      }
    }
  `
  const { data } = await nhost.graphql.request(QUERY, { where: condition })
  return data
}

export const getCandidateUsageCountByPaperId = async (paperId: string) => {
  try {
    const QUERY = gql`
      query getCandidateUsageCountByPaperId($paperId: uuid!) {
        evaluated: evaluation_details_aggregate(where: { evaluation: { paper_id: { _eq: $paperId } } }) {
          aggregate {
            count
          }
        }
      }
    `
    const { data, error }: any = await nhost.graphql.request(QUERY, { paperId })

    if (error) {
      console.log(error, ':error from getCandidateUsageCountByPaperId')
    }

    return data?.evaluated?.aggregate?.count ?? 0
  } catch (err) {
    console.log(err, ':error from getCandidateUsageCountByPaperId')
    return 0
  }
}

export const getSubThemeData = async () => {
  let QUERY = `query getSubThemeData {
  sub_themes {
    id,
    name,
    theme_id,
    theme{
      name,
      report_theme_id,
      report_theme{
        name
      }
    },
    created_at,
  }
}`

  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const exportQuestions = async () => {
  let QUERY = `query exportQuestions {
    questions{
      question_type_id
      id
      strand{
        name
      }
      subject{
        code
        name
        
      }
      theme{
        name
      }
      sub_theme{
        name
      }
      topic{
        name
      }
      grade{
        name
      }
      tn_taxonomy{
        name
      }	
      
      difficulty_level{
        name
    }
    bloom_level{
      name
    }
      status
      userByCreatorId{
        displayName
      }
      title
      option_details
      rubric_option_details
      creator_notes
      reviewer_notes
      approver_notes
      reviewer_stem_comments
      approver_stem_comments
      question_insight

      
    }
  }
      
  `
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const getTestEventById = async (id: any) => {
  let QUERY = `query getTestEventById {
   test_events(where:{id:{_eq:"${id}"}}){
  name,
  id,
  slots
  mode_of_exam,
  location,
  created_at,
  product_id,
  papers{
      sections,
      id,
      paper_smart_id,
      status,
      paper_id,
      active,
      test_track_id,
      paper_template_id
    },

  product{
    name,
    id,
    test_track_ids,
    sections,
    section_ids,
    type,
     paper_templates{
        id,
        name
      }

  }
  paper_requests{
  id,
  name,
  test_track_id
  }
}
}`

  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const getTestTrackDataByIds = async (ids: any) => {
  let QUERY = `query getTestTrackDataByIds {
   test_tracks(where:{id:{_in:${ids}}}){
  name,
  id,
  created_at
  subject{
    name,
    id
  }
}
}`

  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const getAllTestTrackDetails = async () => {
  let QUERY = `query getTestTrackDataByIds {
   test_tracks(order_by: { created_at: desc }){
  name,
  id,
  created_at
  subject_ids
  grade_ids
}
}`

  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const getQuestionsByTopicId = async (topic_id: any) => {
  let QUERY = `query MyQuery {
    questions(where: {topic_id: {_eq: "${topic_id}"}}) {
      title
      question_id
      id
    }
  }`

  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const getQuestionsByCreator = async (user_id: any, userType: any) => {
  let QUERY = `query getQuestionsByCreator {
    work_requests(where:{${userType}:{_eq:"${user_id}"}}){
      id
      name
      count
      questions{
        title
        status
      }
    }
  }`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const getQuestionsBySubjectinCharge = async (user_id: any) => {
  let QUERY = `query getQuestionsBySubjectinCharge{
    work_requests(where: {created_by:{_eq: "${user_id}"}}) {
      id
      name
      count
      questions{
        title
        status
      }
    }
  }`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

//For report of Paper Module Users
export const getPaperRequestForPm = async (user_id: string) => {
  const QUERY = gql`
  query getPaperRequestForPm{paper_requests(where:{created_by:{_eq:"${user_id}"}}){
    name
    paper_template{
      name
    }
    product {
      name
    }
    test_track {
      name
    }
    test_event {
      name
    }
  }}
  `
  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const getPaperTemplateListByPm = async (user_id: string) => {
  const QUERY = gql`
  query getTemplateByPm{paper_templates(where:{created_by:{_eq:"${user_id}"}}){
    id
    name
    paper_template{
      id
    }
    papers{
      id
    }
  }}
  `
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const getTestTrackListByPm = async (user_id: string) => {
  const QUERY = gql`
  query getTestTrackListByPm{test_tracks(where:{created_by:{_eq:"${user_id}"}}){
    id
    name
    paper_templates{
      id
    }
    papers{
      id
    }
  }}
  `
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const getProductListByPm = async (user_id: string) => {
  const QUERY = gql`
  query getProductListByPm{products(where:{created_by:{_eq:"${user_id}"}}){
    id
    name
    paper_templates{
      id
    }
    papers{
      id
    }
    test_event {
      id
    }
  }}
  `
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const getPaperRequestForPsAndPa = async (user_id: string, user_type: string) => {
  const QUERY = gql`
  query getPaperRequestForPsAndPa{paper_requests(where:{${user_type}:{_eq:"${user_id}"}}){
    id
    name
    papers {
      status
    }
  }}
  `
  const { data } = await nhost.graphql.request(QUERY)
  return data
}
//report for evaluation users
export const getEvaluationRequestsByDm = async (user_id: string) => {
  const QUERY = gql`query getEvaluationRequestsByDm {evaluation_requests(where:{created_by:{_eq:"${user_id}"}}){
  id
  name
  evaluators{
    id
    status
    evaluation{
      id
      name
    }
  }
}}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const getEvaluationRequestsByEvaluationIncharge = async (user_id: string) => {
  const QUERY = gql`query getEvaluationRequestsByEvaluationIncharge {evaluation_requests(where: {evaluation_in_charge:{_eq:"${user_id}"}}){
    id
    name
    evaluators{
      id
      status
    }
  }}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const getEvaluationByEvaluator = async (user_id: string) => {
  const QUERY = gql`query getEvaluationByEvaluator {evaluation_evaluators(where:{evaluator_id:{_eq:"${user_id}"}}){
    id
    status
    evaluation_request{
      id
      name
    }
  }}`

  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const getEvaluationRequestList = async () => {
  const QUERY = gql`
    query getEvaluationRequestList {
      evaluation_requests {
        id
        name
        evaluator_ids
        evaluators {
          id
          status
          evaluator_id
        }
      }
    }
  `
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const getThemeDataBySubjects = async (subject_ids: any) => {
  let QUERY = `query getThemeDataBySubjects {
   themes(where:{_and:[{subject_id:{_in:${subject_ids}}},{in_use: { _eq: true }}]}){
  name,
  id,
  report_theme_id,
  subject_id,
  created_at,
  report_theme{
    name,
    id
  },
  subject{
    name,
    id
  }
}
}`

  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const getReportThemeDataBySubjects = async (subject_ids?: any) => {
  let QUERY = `query getReportThemeDataBySubjects {
    report_themes(where:{theme_ids:{_is_null:false}}){
    name
    id
    subject_id
    created_at
    topic_ids
    theme_ids
    subject{
      name
      id
    }
  }
  }`

  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const getReportThemeDataByTopicId = async (topicId: any) => {
  try {
    let QUERY = `query getReportThemeDataBySubjects {
      report_themes(where: { topic_ids: { _contains: "${topicId}" } }) {
        name,
        id,
        subject_id,
        created_at,
        topic_ids,
        subject {
          name,
          id
        }
      }
    }`

    const { error, data } = await nhost.graphql.request(QUERY)
    if (error) {
      return null
    }
    return data
  } catch (err) {
    return false
  }
}

export const getSubThemeBySubjects = async (subject_ids: any) => {
  let QUERY = `query getSubThemeBySubjects {
      sub_themes(where:{_and:[{theme:{subject_id:{_in:${subject_ids}}}},{ in_use: { _eq: true } }]}){
        id
    name
    theme_id
    theme{
      id
      name
      subject_id
    }
}
}`

  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const getTopicBySubjects = async (subject_ids: any) => {
  let QUERY = `query getTopicBySubjects {
      topics(where:{_and:[{sub_theme:{theme:{subject_id:{_in:${subject_ids}}}}},{ in_use: { _eq: true } }]})
{
  name
  id
  sub_theme{
  id
    name
  }
}
}`

  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const getSubSectionByTestTrack = async (templated_id: any) => {
  let QUERY = `query getSubSectionByTestTrack {
      paper_template_sub_sections(where:{paper_template_id:{_eq:"${templated_id}"}})
{
  id
        name
        section_id
        section{
          name
        }
        paper_template_id
        no_of_questions
        mark_per_question
        theme_id
        subject_id
        sub_theme_id
        topic_id
        question_type_id
        report_theme_id
}
}`

  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const getSubSectionByIds = async (templated_ids: any) => {
  let QUERY = `query getSubSectionByTestTrack {
      paper_templates(where:{id:{_in:${templated_ids}}}){
     name
     id
    test_tracks{
      name
    }
    paper_template{
      paper_template_id
      name
      section{
        name
      }
      subject{
        name
      }
      theme{
        name
      }
      sub_theme{
        name
      }
      topic{
        name
      }
      no_of_questions
      mark_per_question
    }
  }
}`

  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const getFlaggedQuestionData = async (questionIds: string[]) => {
  let QUERY = `query getFlaggedQuestionData($questionIds: [uuid]) {
    flagged_questions(where:{question_id:{_in:$questionIds}}){
      id
    }
  }`
  const { data } = await nhost.graphql.request(QUERY, { questionIds })
  return data
}

export const getLastCreatedDraftQuestion = async (condition: any) => {
  let QUERY = gql`
    query getDraft($where: questions_bool_exp) {
      questions(limit: 1, order_by: { created_at: desc }, where: $where) {
        id
      }
    }
  `
  const { data } = await nhost.graphql.request(QUERY, { where: condition })
  return data
}

export const getQuestionLookupIdsByUuids = async (questionUuids: string[]) => {
  if (!Array.isArray(questionUuids) || questionUuids.length === 0) {
    return []
  }

  const QUERY = gql`
    query getQuestionLookupIdsByUuids($ids: [uuid!]!) {
      questions(where: { id: { _in: $ids } }) {
        id
        question_id
      }
    }
  `

  const { data } = (await nhost.graphql.request(QUERY, { ids: questionUuids })) as {
    data?: { questions?: { id: string; question_id: string | number }[] }
  }
  return data?.questions || []
}

export const getQuestionAnswers = async (questionIds: string[]) => {
  console.log(questionIds, 'question answers')
  let QUERY = `query getMCQQuestionAnswers {
    questions(where:{id:{_in:${questionIds}}}){
      id
      option_details
      question_type_id
  }
}`

  const { error, data }: any = await nhost.graphql.request(QUERY)
  console.log(data, 'question answers')
  interface alphabetsType {
    [key: number]: string
  }
  const alphabets: alphabetsType = { 1: 'a', 2: 'b', 3: 'c', 4: 'd', 5: 'e', 6: 'f', 7: 'g', 8: 'h' }

  let returnData: any = []
  data?.questions?.forEach((item: any) => {
    const questionType = item?.question_type_id

    const correctOptionIndex = item?.option_details?.findIndex((option: any) => option?.option_flag === 'Right Answer')

    //Fill in the blanks answers
    let fillAnswers: any[] = []
    item?.option_details?.forEach((item: any) => {
      fillAnswers.push(item?.right_answer)
    })

    if (questionType === 'MCQ') {
      returnData.push({
        id: item?.id,
        questionType: questionType,
        rightOption: alphabets[correctOptionIndex + 1] || 'nil',
      })
    } else if (questionType === 'Fill') {
      returnData.push({
        id: item?.id,
        questionType: questionType,
        rightAnswers: fillAnswers,
      })
    } else {
      returnData.push({
        id: item?.id,
        questionType: questionType,
      })
    }
  })

  return returnData
}

export const getQuestionsAndOptions = async (questionIds: any, paperId = '') => {
  const entities = paperId
    ? `title option_details question_type_id question_id question{status qb_permit id bloom_level{id name} difficulty_level{id name} language questionByTransilationOf{title option_details}}`
    : `id option_details title question_type_id question_id status qb_permit language difficulty_level{id name} bloom_level{id name} questionByTransilationOf{title option_details}`
  const tableName = paperId ? `paper_question_snapshots` : `questions`
  let whereClause = ''
  if (paperId) {
    whereClause = `{ _and: [ { original_question_uuid: { _in: ${questionIds} } }, { paper_id: { _eq: "${paperId}" } } ] }`
  } else {
    whereClause = `{ id: { _in: ${questionIds} } }`
  }

  const QUERY = `
  query getMCQQuestionAnswers {
    ${tableName}(where: ${whereClause}) {
      ${entities}
    }
  }
`

  const { data, error }: any = await nhost.graphql.request(QUERY)
  return data?.[tableName]
}

export const getPaperById = async (paper_id: any) => {
  let QUERY = `query getPaperById {
    papers(where:{id:{_eq:"${paper_id}"}}){
      id
      questionAnswerKeys
  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const getLastEvaluation = async () => {
  let QUERY = `query {
   evaluations(limit: 1, order_by: {created_at: desc}) {
    id
  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const getEvaluationDetails = async (id: any, evaluator_id: any) => {
  let QUERY = `query {
   evaluation_details(where:{evaluation_id:{_eq:"${id}"},evaluator_id:{_eq:"${evaluator_id}"}}, order_by: {created_at: desc}) {
    id
    candidate_id
    candidate_name
    application_id
  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

export const getQuestionUsageAnalysis = async (id: any) => {
  let QUERY = `query {
    question_usage_analysis_aggregate(where: {question_id: {_eq:"${id}"}}) {
      nodes {
        test_event_id
        section_id
        question_id
        paper_id
        section {
          name
        }
        question {
          question_id
        }
        paper {
          paper_id
          paper_smart_id
        }
        test_event{
          name
        }
      }
    }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const getReportThemeBySubject = async (subject_id: any) => {
  let QUERY = `query{
  report_themes(where:{topic:{sub_theme:{theme:{subject_id:{_eq:"${subject_id}"}}}}}){
   id
    name
}
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const deleteWorkRequestGrades = async (wr_id: string) => {
  let QUERY = `query deleteWorkRequestGrades{
 delete_work_request_grades(where:{work_request_id:{_eq:"${wr_id}"}}){
    affected_rows
  }
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const getTeacherLevelByStrand = async (strand_id: any) => {
  let QUERY = `query{
  strands(where:{id:{_eq:"${strand_id}"}}){
    teacher_level{
    name
  }
}
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const getSubSectionDetails = async (paper_template_id: string) => {
  let QUERY = `subscription getSubSectionDetails {
  paper_template_sub_sections(where:{paper_template_id:{_eq:"${paper_template_id}"}}){
  
    name
    id
    section_id
    section{
      id
      name
    }
    paper_template_id
    question_type_id
    question_type{
      id
      name
    }
    no_of_questions
    mark_per_question
    theme_id
    theme{
      id
      name
    }
    report_theme_id
    report_theme{
      id
      name
    }
    subject_id
    subject{
      id
      name
    }
    sub_theme_id
    sub_theme{
      id
      name
    }
    topic_id
    topic{
      id
      name
    }
}
}`
  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const SearchBloomLevelDuplicate = async (text: number) => {
  let QUERY = `query SearchBloomLevelDuplicate{
    blooms_levels(where:{order:{_eq:${text}}}order_by:{order:desc}){
   
    name
    order
  }
  } `

  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const SearchDifficultLevelDuplicate = async (text: number) => {
  let QUERY = `query SearchDifficultLevelDuplicate{
     difficulty_levels(where:{order:{_eq:${text}}}order_by:{order:desc}){
 
    name
    order
  }
  } `

  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const getFilteredQuestions = async (values: any) => {
  let whereQuery = ''
  if (values?.question_type_ids && values?.question_type_ids?.length > 0) {
    whereQuery += `question_type_id:{_in:${JSON.stringify(values?.question_type_ids)}},`
  }
  if (values?.subject_ids && values?.subject_ids?.length > 0) {
    whereQuery += `subject_id:{_in:${JSON.stringify(values?.subject_ids)}},`
  }
  if (values?.grade_ids && values?.grade_ids?.length > 0) {
    whereQuery += `question_grades:{grade_id:{ _in: ${JSON.stringify(values?.grade_ids)}}},`
  }
  if (values?.status_ids && values?.status_ids?.length > 0) {
    whereQuery += `status:{_in:${JSON.stringify(values?.status_ids)}},`
  }
  if (values?.work_requests && values?.work_requests?.length > 0) {
    whereQuery += `work_request_id:{_in:${JSON.stringify(values?.work_requests)}},`
  }
  let QUERY = ''
  if (whereQuery !== '') {
    QUERY = `
   query{
  questions(where:
   {${whereQuery}}
    
  ) {
    question_id
    question_type_id
      id
      strand{
        name
      }
      subject{
        code
        name
        
      }
      theme{
        name
      }
      sub_theme{
        name
      }
      topic{
        name
      }
      grade{
        name
      }
      tn_taxonomy{
        name
      }	
      
      difficulty_level{
        name
    }
    bloom_level{
      name
    }
      status
      userByCreatorId{
        displayName
      }
      title
      option_details
      rubric_option_details
      creator_notes
      reviewer_notes
      approver_notes
      reviewer_stem_comments
      approver_stem_comments
      question_insight
      
      question_grades{
        grade{
          name
          id
        }
      }

    
  }
}
   `
    const { data } = await nhost.graphql.request(QUERY)
    return data
  } else {
    return exportQuestions()
  }
  //  console.log({QUERY,whereQuery})
}
export const getEvaluationRequestDetailsByUser = async (userid: string, userRole: string) => {
  let QUERY = ''
  if (userRole === 'evaluationincharge') {
    QUERY = `query evaluation_requests_aggregate{
  evaluation_requests_aggregate(where:{evaluation_in_charge:{_eq:"${userid}"}}){
    aggregate{
      count
    }
  }
}`
  } else if (userRole === 'evaluators') {
    QUERY = `query evaluation_requests_aggregate{
  evaluation_requests_aggregate(where:{evaluator_ids:{_contains:"${userid}"},status:{_neq:"Open"}}){
    aggregate{
      count
    }
  }
}`
  } else if (userRole === 'deliverymanager') {
    QUERY = `query evaluation_requests_aggregate{
  evaluation_requests_aggregate(where:{created_by:{_eq:"${userid}"}}){
    aggregate{
      count
    }
  }
}`
  }
  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const getEvaluationRequestDetailsByUserStatus = async (userid: string, userRole: string) => {
  let QUERY = ''
  if (userRole === 'evaluationincharge') {
    QUERY = `query evaluation_requests_aggregate{
  evaluation_requests_aggregate(where:{evaluation_in_charge:{_eq:"${userid}"},,status:{_eq:"Score Finalised"}}){
    aggregate{
      count
    }
  }
}`
  } else if (userRole === 'evaluators') {
    QUERY = `query{
  evaluation_requests_aggregate(where:{evaluator_ids:{_contains:"${userid}"},,status:{_eq:"Score Finalised"}}){
    aggregate{
      count
    }
  }
}`
  } else if (userRole === 'deliverymanager') {
    QUERY = `query evaluation_requests_aggregate{
  evaluation_requests_aggregate(where:{created_by:{_eq:"${userid}"},status:{_eq:"Score Finalised"}}){
    aggregate{
      count
    }
  }
}`
  }
  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const getHistoryLogDetailsByComponent = async (comp_name: string, ref_id: string) => {
  let return_data
  if (comp_name === 'work_requests') {
    return_data = `{
      name
      status
      subject{
        name
      }
      request_type
      question_type{
        name
      }
    }`
  } else if (comp_name === 'questions') {
    return_data = `{
      title
      status
      subject{
        name
      }
      
      question_type{
        name
      }
    }`
  } else if (
    comp_name === 'mediums' ||
    comp_name === 'blooms_levels' ||
    comp_name === 'difficulty_levels' ||
    comp_name === 'grade_levels' ||
    comp_name === 'subjects' ||
    comp_name === 'sections' ||
    comp_name === 'teacher_levels' ||
    comp_name === 'check_lists' ||
    comp_name === 'centa_concepts' ||
    comp_name === 'explanation_types'
  ) {
    return_data = `{
      name
    }`
  } else if (comp_name === 'report_themes') {
    return_data = `{
      name
      subject{
        name
      }
    }`
  } else if (comp_name === 'themes') {
    return_data = `{
      name
      report_theme{
        name
        subject{
          name
        }
      }
    }`
  } else if (comp_name === 'themes') {
    return_data = `{
      name
      report_theme{
        name
        subject{
          name
        }
      }
    }`
  } else if (comp_name === 'sub_themes') {
    return_data = `{
      name
      theme{
        name
        report_theme{
          name
        }
        subject{
          name
        }
      }
    
    }`
  } else if (comp_name === 'topics') {
    return_data = `{
      name
      sub_theme{
        name
        theme{
          name
          report_theme{
            name
            subject{
              name
            }
          }
          
        }
      }
    
    }`
  } else if (comp_name === 'grades') {
    return_data = `{
     name
     grade_levels{
      name
    }
    }`
  } else if (comp_name === 'competencies') {
    return_data = `{
      name
      competency_type{
        name
      }
    }`
  } else if (comp_name === 'tn_taxonomys') {
    return_data = `{
      name
      competencies{
        name
      }
    }`
  } else if (comp_name === 'strands') {
    return_data = `{
      name
    competency{
      name
    }
    taxonomy{
      name
    }
    teacher_level{
      name
    }
    }`
  }
  let QUERY = gql` query getHistoryLogDetailsByComponent{
    ${comp_name}(where:{id:{_eq:"${ref_id}"}})
      ${return_data}
     
    
  }
  
  `
  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const getAcceptedQuestionCountCreators = async (id: string) => {
  let QUERY = gql`
    query  {
      questions_aggregate(where:{creator_id:{_eq:"${id}"},status:{_in:"${approverStatus}"}}){
   aggregate{
    count
  } 
  }
    }
  `
  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const getAcceptedQuestionCountReviewers = async (id: string) => {
  let QUERY = gql`
    query  {
      questions_aggregate(where:{reviewer_id:{_eq:"${id}"},status:{_eq:"Published"}}){
   aggregate{
    count
  } 
  }
    }
  `
  const { data } = await nhost.graphql.request(QUERY)
  return data
}
export const getParentQuestionIds = async () => {
  let QUERY = gql`
    query getParentQuestionIds {
      questions(where: { parent_question_id: { _is_null: false } }) {
        parent_question_id
      }
    }
  `
  const { data } = await nhost.graphql.request(QUERY)
  return data
}

///----------------------------------------------------------------------------------------------------------------

export const findThePaperByEvaluationId = async (evaluationId: string) => {
  try {
    const QUERY = gql`
     query getPaperByEvaluationId{
      evaluations(where:{id:{_eq:"${evaluationId}"}}){
        paper_id,
        created_at,
          paper{
          paper_template_id,
          subSectionQuestions,
          test_track_id,
          product_id,
          questionAnswerKeys
        }
      }
     }
     `
    const { data } = await nhost.graphql.request(QUERY)
    return data
  } catch (err) {
    console.log(err, 'got this error on find the paper using evaluation Id')
  }
}
export const findTestTrackName = async (testTrackId: string) => {
  try {
    const QUERY = gql`
     query getTestTrackDetails{
      test_tracks(where:{id:{_eq:"${testTrackId}"}}){
        id,name,grade_ids,subject_ids
      }
     }
     `
    const { data } = await nhost.graphql.request(QUERY)
    return data
  } catch (err) {
    console.log(err, 'got this error from find the test track name')
  }
}

export const findSubsectionDetailsById = async (subsectionId: string) => {
  try {
    const QUERY = gql`
query getSubsectionDetailsById{
  paper_template_sub_sections(where:{id:{_eq:"${subsectionId}"}}){
    id,
    name,
    section_id,
    paper_template_id,
    report_theme_id,
    report_theme{
    id,
    name
    },
    section{
      name
    }

  }
}
`
    const { data } = await nhost.graphql.request(QUERY)
    return data
  } catch (err) {
    console.log(err, 'error from findSubsectionDetailsById ')
  }
}

export const findQuestionDetailsById = async (questionId: string) => {
  try {
    const QUERY = gql`
    query findQstnDetailsById{
      questions(where:{id:{_eq:"${questionId}"}}){
        id,
        status,
        question_id,
        question_type_id,
        active,
        option_details,
        title,
        bloom_level{
          id,name
        },
        centa_standard{
          id,name
        },
        competencies{
          competency_id,name
        },
        difficulty_level{
          id,name
        },
        tn_taxonomy{
          id,name
        },
        report_theme{
          id,name
        },
        sub_theme{
          id,name
        },
        topic{
          id,name
        },
        theme{
          id,name
        },
        subject{
        id,name
        }

      }
    }
    `
    const { data } = await nhost.graphql.request(QUERY)

    return data
  } catch (err) {
    console.log(err, 'error on findQuestionDetailsById')
  }
}
export const findQuestionOptionDetailsById = async (questionId: string) => {
  try {
    const QUERY = gql`
    query findQstnOptionDetailsById{
      questions(where:{id:{_eq:"${questionId}"}}){
        id,
        option_details,
      }
    }
    `
    const { data } = await nhost.graphql.request(QUERY)

    return data
  } catch (err) {
    console.log(err, 'error on findQuestionDetailsById')
  }
}

export const findCandidateResult = async (candidateId: string, evaluationId: string) => {
  try {
    const QUERY = gql`
  query findCandidateResultByID{
  evaluation_details(where:{candidate_id:{_eq:"${candidateId}"},evaluation_id:{_eq:"${evaluationId}"}}){
    answers,
    total_score,
    is_attended,
    is_eligible_for_result
  }
}
`
    const { data } = await nhost.graphql.request(QUERY)
    // console.log(data,"data is this")
    return data
  } catch (err) {
    console.log(err, 'err from find candidates')
  }
}
export const findEvaluatonDetailsByCandidateId = async (candidateId: string) => {
  try {
    const QUERY = gql`
  query findEvaluatonDetailsByCandidateId{
  evaluation_details(where:{candidate_id:{_eq:"${candidateId}"}}){
    candidate_name,
    total_score,
    evaluation_id
  }
}
`
    const { data } = await nhost.graphql.request(QUERY)
    // console.log(data,"data is this")
    return data
  } catch (err) {
    return false
  }
}

export const findMhReportCardByCandidateId = async (candidateId: string) => {
  try {
    const QUERY = gql`
    query findMhReportCardByCandidateId{
      Mh_report_card(where:{candidate_id:{_eq:"${candidateId}"}}){
      id
      candidate_id
      candidate_name
      employee_id
      venue
      udise_code
      paper_name
      total_obtained_score
      paper_total_score
      percentage_obtained
      correct_count
      all_section_total
      badge_winner
      section_wise_details
      blooms_details
      created_at
    }
  }
  `
    const { data } = await nhost.graphql.request(QUERY)

    return data
  } catch (err) {
    return false
  }
}

export const findCandidateReportDetails = async (candidateId: any) => {
  try {
    const QUERY = gql`
    query findEvaluatonDetailsByCandidateId{
      candidate_report_data(where:{candidate_id:{_eq:"${candidateId}"}}){
      candidate_id,
      candidate_name,
      section_level_details,
      blooms_level_details,
      option_flag_details,
      national_average_details,
      section_wise_report_theme_details
      skt_id
      issue_date
      is_attended
      is_eligible_for_result
      is_visible
    }
  }
  `
    const { data } = await nhost.graphql.request(QUERY)

    return data
  } catch (err) {
    return false
  }
}

// export const findEvaluatonDetailsByCandidateId = async (candidateId: string, ) => {
//   try {
//     const QUERY = gql`
//       query findEvaluatonDetailsByCandidateId($candidateId: String!, $role: String!) {
//         evaluation_details(where: { candidate_id: { _eq: $candidateId } }) {
//           candidate_name
//           total_score
//           evaluation_id
//         }
//       }
//     `;

//     const variables = {
//       candidateId,
//       role:"admin",
//     };

//     const data = await nhost.graphql.request(QUERY, variables);

//     console.log(data, "data is this");
//     return data;
//   } catch (err) {
//     console.error(err);
//     return false;
//   }
// };

export const findCandidateResultByID = async (candidateId: string) => {
  try {
    const QUERY = gql`
  query findCandidateResultByID{
  evaluation_details(where:{id:{_eq:"${candidateId}"}}){
    answers,
    total_score
  }
}
`
    const { data } = await nhost.graphql.request(QUERY)
    return data
  } catch (err) {
    console.log(err, 'err from find candidates')
  }
}

export const findPapersByTestTrackId = async (testTrackId: string, productId?: string) => {
  try {
    const productCheck = productId ? `,product_id:{_eq:"${productId}"}` : ''
    const QUERY = gql`
  query findThePaperByProductAndTestTrackId{
    papers(where:{test_track_id:{_eq:"${testTrackId}"}${productCheck}}){
      id,
      subSectionQuestions
    }
  }
  `
    const { data } = await nhost.graphql.request(QUERY)
    return data
  } catch (err) {
    console.log(err, ' :error from findPapersByProductIDandTestTrackId')
    return null
  }
}

// Whole candidate population (all schools) that attended & are eligible, used to compute a
// true national average from candidate_report_data instead of a rolling evaluation window.
export const findCandidateReportsForNationalAverage = async (testTrackId: string, productId?: string, testType?: string) => {
  try {
    const normalizedTestType = testType?.toLowerCase()
    const productCheck =
      (normalizedTestType === 'skt' || normalizedTestType === 'te') && productId ? `,product_id:{_eq:"${productId}"}` : ''
    const testTypeCheck = normalizedTestType ? `,test_type:{_eq:"${normalizedTestType}"}` : ''
    const QUERY = gql`
    query findCandidateReportsForNationalAverage{
      candidate_report_data(where:{test_track_id:{_eq:"${testTrackId}"}${productCheck}${testTypeCheck},is_attended:{_eq:true},is_eligible_for_result:{_eq:true}}){
        school_id,
        section_level_details
      }
    }
    `
    const { data } = await nhost.graphql.request(QUERY)
    return data
  } catch (err) {
    console.log(err, ' :error from findCandidateReportsForNationalAverage')
    return null
  }
}

export const findEvaluationDetailsByPaperIdAndDate = async (paperId: string, validationDate: string) => {
  try {
    const QUERY = gql`
    query findEvaluationDetailsByPaperIdAndDate{
    evaluations(where:{paper_id:{ _eq:"${paperId}"},created_at:{ _gte:"${validationDate}"}}){
      id,
      created_at,
      evaluation_candidates{
        id,
        total_score
      },
      paper{
        id,
        subSectionQuestions
      }
    }
  }
  `
    const { data } = await nhost.graphql.request(QUERY)
    return data
  } catch (err) {
    console.log(err, ' :error')
  }
}

/** Same shape as findEvaluationDetailsByPaperIdAndDate rows — used to include the current evaluation even outside the lookback window. */
export const findEvaluationByIdForNationalAverage = async (evaluationId: string) => {
  try {
    const QUERY = gql`
    query findEvaluationByIdForNationalAverage{
    evaluations(where:{id:{ _eq:"${evaluationId}"}}){
      id,
      created_at,
      evaluation_candidates{
        id,
        total_score
      },
      paper{
        id,
        subSectionQuestions
      }
    }
  }
  `
    const { data } = await nhost.graphql.request(QUERY)
    return data
  } catch (err) {
    console.log(err, ' :error from findEvaluationByIdForNationalAverage')
    return null
  }
}

export const evaluationDetailsByPaperId = async (paperId: string) => {
  try {
    const QUERY = gql`
  query findEvaluationDetailsByPaperId{
    evaluations(where:{paper_id:{_eq:"${paperId}"},created_at:{}}){
      id,
    }
  }
  `
  } catch (err) {
    console.log(err, 'error from evaluation details by paperId')
  }
}

export const findSectionIdFromProduct = async (productId: string) => {
  try {
    const QUERY = gql`
  query findSectionInProduct{
    products(where:{id:{_eq:"${productId}"}}){
      id,
      sections,
      total_marks,
      total_questions
    }
  }
  `
    const { data } = await nhost.graphql.request(QUERY)
    return data
  } catch (err) {
    console.log(err, 'error')
  }
}

export const findSectionNameById = async (sectionId: string) => {
  try {
    const QUERY = gql`
   query findSectionInProduct{
    sections(where:{id:{_eq:"${sectionId}"}}){
      id,
      name
    }
  }
  `
    const { data } = await nhost.graphql.request(QUERY)
    return data
  } catch (err) {
    console.log(err, 'error')
  }
}

export const fetchAllNationalAverage = async () => {
  try {
    const QUERY = gql`
      query findNationalAverage {
        national_average {
          id
          section_wise_average
          product_name
          test_track_name
        }
      }
    `
    const data = await nhost.graphql.request(QUERY)
    return data
  } catch (err) {
    console.log(err, 'err on fetching national average')
  }
}

export const isAuthenticatedCandidate = async (candidateId: string) => {
  try {
    const QUERY = gql`
      query checkIsCandidateIsAuthenticatedOrNot {
        candidate
      }
    `
  } catch (err) {
    console.log(err, 'error from authenticating candidate')
  }
}

// export const getEvaluationDetailsByEvaluationId=async(evaluationId:string)=>{
//   try{
//     const QUERY = gql`
//     query findPaperId{
//      evaluations(where:{id:{_eq:"${evaluationId}"}}){
//        paper_id,
//       }
//    }
//    `
//     const { data } = await nhost.graphql.request(QUERY)
//     return data

//   }catch(err){
//     console.log(err)
//   }
// }

export const findPaperTotalMarksWithEvaluationId = async (evaluationId: string) => {
  try {
    const QUERY = gql`
    query findPaperId{
     evaluations(where:{id:{_eq:"${evaluationId}"}}){
       paper_id,
       created_at,
       paper{
       paper_request_id
       }
       evaluation_request{
       test_events{
       id
       name
       slots
       }
       }
      }
   }
   `
    const { data } = (await nhost.graphql.request(QUERY)) as any
    if (data) {
      const paperId = data?.evaluations[0]?.paper_id
      const projectDetails = data?.evaluations[0].paper?.paper_request?.project_id || ''
      const testEventDetails = data?.evaluations[0].evaluation_request?.test_events
      const evalationCreatedDate = data?.evaluations[0]?.created_at
      if (paperId) {
        const QUERY = gql`
        query findProductTotal{
         papers(where:{id:{_eq:"${paperId}"}}){
           product{
            total_marks,
            tq,
            type
           }
           test_track_id,
           product_id,
           slot_data,
           test_track{
            name
          },
          product{
            name
          }
          }
        }
       `
        const { data, error } = (await nhost.graphql.request(QUERY)) as any
        const total_marks = data?.papers[0]?.product.total_marks
        const tq = data?.papers[0]?.product?.tq
        const testType = data?.papers[0]?.product?.type
        const test_track_id = data?.papers[0]?.test_track_id
        const product_id = data?.papers[0]?.product_id
        const product_name = data?.papers[0]?.product?.name
        const test_track_name = data?.papers[0]?.test_track?.name
        const slotData = data?.papers[0]?.slot_data
        return {
          total_marks,
          test_track_id,
          product_id,
          product_name,
          test_track_name,
          slotData,
          paperId,
          projectDetails,
          tq,
          testEventDetails,
          testType,
          evalationCreatedDate,
        }
      } else {
        return false
      }
    } else {
      return false
    }
  } catch (err) {
    console.log(err, 'error while find the total marks of a paper ')
  }
}

export const isAddNationalAverage = async (test_track_id: string, productId?: string) => {
  try {
    const productCheck = productId ? `,product_id:{_eq:"${productId}"}` : `,tq:{_eq:true}`
    const QUERY = gql`
  query isAddNationalAverage{
    national_average(where:{test_track_id:{_eq:"${test_track_id}"}${productCheck}}){
      id,created_at,section_wise_average,total_national_average,tq
    }
  }
  `
    const { data, error } = await nhost.graphql.request(QUERY)
    if (error) {
      console.log(error, 'error from isAddNationalAverage')
      return null
    }
    return data
  } catch (err) {
    console.log(err, 'error')
    return null
  }
}
//candidate report data
// Stored public DigitalOcean scorecard PDFs for these candidates (newer links point at the AMS page instead).
export const getStoredScoreCardPdfLinks = async (candidateIds: string[]) => {
  const QUERY = gql`
    query getStoredScoreCardPdfLinks($candidateIds: [String!]!) {
      candidate_report_data(where: { candidate_id: { _in: $candidateIds }, score_card_url: { _like: "%digitaloceanspaces.com%" } }) {
        candidate_id
        score_card_url
      }
    }
  `
  const { data, error }: any = await nhost.graphql.request(QUERY, { candidateIds })
  if (error) {
    throw error
  }
  return (data?.candidate_report_data || []) as { candidate_id: string; score_card_url: string }[]
}

export const isCandidateHaveReportResult = async (candidateId: string) => {
  try {
    const QUERY = gql`
      query getCandidateReportResult {
        candidate_report_data(where:{candidate_id:{_eq:"${String(candidateId ?? '').replace(/@centa\.org$/i, '')}"}}){
          id
          candidate_name
        }
      }
    `
    const { data } = await nhost.graphql.request(QUERY)
    return data
  } catch (err) {
    console.log(err, 'error')
  }
}
//-
export const findSubsectionDetails = async (subsection: string) => {
  try {
    const QUERY = gql`
query findSubsectionDetails{
  paper_template_sub_sections(where:{id:{_eq:"${subsection}"}}){
    id,
    name,
    section{
      name
    },
    mark_per_question,
    question_type_id,
    report_theme{
      name
    },
    sub_theme{
      name
    },
    subject{
      name
    },
    theme{
      name
    }
  }
}
`
    const { data, error } = await nhost.graphql.request(QUERY)
    if (data) {
      return data
    } else {
      console.log(error, 'error from findSubsectionDetails query')
    }
  } catch (err) {
    console.log(err, 'error from subsection details')
  }
}

export const getProductCount = async () => {
  try {
    const QUERY = gql`
      query getCountOfProduct {
        products_aggregate(where: { active: { _eq: "true" } }) {
          aggregate {
            count
          }
        }
      }
    `
    const { data, error } = await nhost.graphql.request(QUERY)
    return data
  } catch (err) {
    console.log(err, 'error from get product query')
  }
}

//finding count for different tables
export const getCount = async (details: any) => {
  try {
    const findCountQuery = (details: any) => {
      if (details?.resource === 'test track') {
        const QUERY = gql`
          query getCountFromlist {
            test_tracks_aggregate {
              aggregate {
                count
              }
            }
          }
        `
        return QUERY
      } else if (details?.resource === 'paper template') {
        if (details?.isAdmin) {
          const QUERY = gql`
            query getCountFromlist {
              completedCount: paper_templates_aggregate(where: { active: { _eq: "true" }, is_completed: { _eq: "true" } }) {
                aggregate {
                  count
                }
              }
              notCompletedCount: paper_templates_aggregate(where: { active: { _eq: "true" }, is_completed: { _eq: "false" } }) {
                aggregate {
                  count
                }
              }
            }
          `
          return QUERY
        } else {
          const QUERY = gql`
          query getCountFromlist {
            completedCount: paper_templates_aggregate(where: { active: { _eq: "true" }, created_by:{_eq:"${details?.userId}"}, is_completed: { _eq: "true" } }) {
              aggregate {
                count
              }
            }
            notCompletedCount: paper_templates_aggregate(where: { active: { _eq: "true" }, created_by:{_eq:"${details?.userId}"}, is_completed: { _eq: "false" } }) {
              aggregate {
                count
              }
            }
          }
        `
          return QUERY
        }
      } else if (details?.resource === 'papers') {
        // product managers see every paper in the list, so count every paper too
        if (details?.isAdmin || details?.userrole === 'productmanager') {
          const QUERY = gql`
            query getCountFromlist {
              approvedCount: papers_aggregate(where: { active: { _eq: "true" }, status: { _eq: "Approved" } }) {
                aggregate {
                  count
                }
              }
              forApprovelCount: papers_aggregate(where: { active: { _eq: "true" }, status: { _eq: "For Approval" } }) {
                aggregate {
                  count
                }
              }
              requireAmendingCount: papers_aggregate(where: { active: { _eq: "true" }, status: { _eq: "Require Amending" } }) {
                aggregate {
                  count
                }
              }
              unfilledPaperCount: papers_aggregate(where: { active: { _eq: "true" }, status: { _eq: "Unfilled Paper" } }) {
                aggregate {
                  count
                }
              }
            }
          `
          return QUERY
        } else {
          const field =
            details?.userrole === 'productmanager'
              ? `paper_request: {created_by:{_eq:"${details?.userId}"}}`
              : details?.userrole === 'paperapprover'
              ? `paper_approver_id:{_eq:"${details?.userId}"}`
              : `current_paper_setter_id:{_eq:"${details?.userId}"}`

          const QUERY = gql`
            query getCountFromlist {
              approvedCount: papers_aggregate(where: { active: { _eq: "true" }, ${field}, status: { _eq: "Approved" } }) {
                aggregate {
                  count
                }
              }
              forApprovelCount: papers_aggregate(where: { active: { _eq: "true" }, ${field}, status: { _eq: "For Approval" } }) {
                aggregate {
                  count
                }
              }
              requireAmendingCount: papers_aggregate(where: { active: { _eq: "true" }, ${field}, status: { _eq: "Require Amending" } }) {
                aggregate {
                  count
                }
              }
              unfilledPaperCount: papers_aggregate(where: { active: { _eq: "true" }, ${field}, status: { _eq: "Unfilled Paper" } }) {
                aggregate {
                  count
                }
              }
            }
          `
          return QUERY
        }
      } else if (details?.resource === 'paper requests') {
        if (details?.isAdmin) {
          const QUERY = gql`
            query getCountFromlist {
              openPaperRequestCount: paper_requests_aggregate(where: { status: { _eq: "Open" } }) {
                aggregate {
                  count
                }
              }
              inProgressPaperRequestCount: paper_requests_aggregate(where: { status: { _eq: "In Progress" } }) {
                aggregate {
                  count
                }
              }
              completedPaperRequestCount: paper_requests_aggregate(where: { status: { _eq: "Completed" } }) {
                aggregate {
                  count
                }
              }
            }
          `
          return QUERY
        } else {
          const field =
            details?.userrole === 'productmanager' ? 'created_by' : details?.userrole === 'paperapprover' ? 'paper_approver_id' : 'paper_setter_id'
          const QUERY = gql`
            query getCountFromlist {
              openPaperRequestCount: paper_requests_aggregate(where: { status: { _eq: "Open" }, ${field}:{_eq:"${details?.userId}"} }) {
                aggregate {
                  count
                }
              }
              inProgressPaperRequestCount: paper_requests_aggregate(where: { status: { _eq: "In Progress" }, ${field}:{_eq:"${details?.userId}"} }) {
                aggregate {
                  count
                }
              }
              completedPaperRequestCount: paper_requests_aggregate(where: { status: { _eq: "Completed" }, ${field}:{_eq:"${details?.userId}"} }) {
                aggregate {
                  count
                }
              }
            }
          `
          return QUERY
        }
      } else if (details?.resource === 'questions') {
        const workRequestTypeFilter =
          details?.userrole === 'qcreator'
            ? 'work_request:{request_type: {_eq:"Q"}}'
            : details?.userrole === 'variantcreator'
            ? 'work_request:{request_type:{_eq:"V"}}'
            : ''

        const roleWiseFilter =
          details?.userrole === 'subjectincharge'
            ? `work_request: {${details.subjectinchargeField}: {_eq:"${details.userId}"}}`
            : details?.userrole === 'qapprover'
            ? `_or:[{approver_id: { _eq:"${details.userId}"}},{second_approver_id: { _eq:"${details?.userId}"}}]`
            : details?.userrole === 'qreviewer'
            ? `_or:[{reviewer_id: { _eq:"${details.userId}"}},{second_reviewer_id: { _eq:"${details?.userId}"}}]`
            : details?.userrole === 'qcreator' || details?.userrole === 'variantcreator'
            ? `creator_id: {_eq:"${details.userId}"}`
            : ''

        const requestTypeFilter = ''

        // const requestTypeFilter =
        // details?.userrole === 'qcreator' || details?.userrole === 'variantcreator' ? 'request_type: {_eq:"Q"}':''

        const QUERY = gql`
          query getCountFromlist {
            forApprovalCount: questions_aggregate(where: {active: {_eq:"true"}, request_type: {_neq:"Uploaded"}, ${workRequestTypeFilter}, ${roleWiseFilter}, status:{_eq:"For Approval"}}){
              aggregate{
                count
              }
            }
            publishedCount: questions_aggregate(where: {active: {_eq:"true"}, request_type: {_neq:"Uploaded"}, ${workRequestTypeFilter}, ${roleWiseFilter},  status:{_eq:"Published"}}){
              aggregate{
                count
              }
            }
            rejectedAtApprovalCount: questions_aggregate(where: {active: {_eq:"true"}, request_type: {_neq:"Uploaded"}, ${workRequestTypeFilter}, ${roleWiseFilter},  status:{_eq:"Rejected at Approval"}}){
              aggregate{
                count
              }
            }
            requireAmendingCount: questions_aggregate(where: {active: {_eq:"true"}, request_type: {_neq:"Uploaded"}, ${workRequestTypeFilter}, ${roleWiseFilter},  status:{_eq:"For Review (Require Amending)"}}){
              aggregate{
                count
              }
            }
            forReviewCount: questions_aggregate(where: {active: {_eq:"true"}, request_type: {_neq:"Uploaded"}, ${workRequestTypeFilter}, ${roleWiseFilter},  status:{_eq:"For Review"}}){
              aggregate{
                count
              }
            }
            openRequireAmendingCount: questions_aggregate(where: {active: {_eq:"true"}, request_type: {_neq:"Uploaded"}, ${workRequestTypeFilter}, ${roleWiseFilter},  status:{_eq:"Open (Require Amending)"}}){
              aggregate{
                count
              }
            }
            openCount: questions_aggregate(where: {active: {_eq:"true"}, request_type: {_neq:"Uploaded"}, ${workRequestTypeFilter}, ${roleWiseFilter}, status:{_eq:"Open"}}){
              aggregate{
                count
              }
            }
            rejectedAtReviewCount: questions_aggregate(where: {active: {_eq:"true"}, request_type: {_neq:"Uploaded"}, ${workRequestTypeFilter}, ${roleWiseFilter}, status:{_eq:"Rejected at Review"}}){
              aggregate{
                count
              }
            }
            secondReviewCount: questions_aggregate(where: {active: {_eq:"true"}, request_type: {_neq:"Uploaded"}, ${workRequestTypeFilter}, ${roleWiseFilter},  status:{_eq:"For Second Review"}}){
              aggregate{
                count
              }
            }
            retriedCount: questions_aggregate(where: {active: {_eq:"true"}, request_type: {_neq:"Uploaded"}, ${workRequestTypeFilter}, ${roleWiseFilter},  status:{_eq:"Retired"}}){
              aggregate{
                count
              }
            }
            secondApprovalCount: questions_aggregate(where: {active: {_eq:"true"}, request_type: {_neq:"Uploaded"}, ${workRequestTypeFilter}, ${roleWiseFilter},  status:{_eq:"For Second Approval"}}){
              aggregate{
                count
              }
            }
            
          }
          `
        return QUERY
      } else if (details?.resource === 'work_requests') {
        const roleWiseFilter =
          details?.userrole === 'subjectincharge'
            ? `_or:[{subject_incharge_id: { _eq:"${details.userId}"}},{created_by: { _eq:"${details?.userId}"}}]`
            : details?.userrole === 'qcreator' || details?.userrole === 'variantcreator'
            ? `creator_id: {_eq:"${details.userId}"}`
            : details?.userrole === 'qapprover'
            ? `workRequestApprovers:{approver_id:{_eq:"${details.userId}"}}`
            : details?.userrole === 'qreviewer'
            ? `workRequestReviewers:{user_id:{_eq:"${details.userId}"}}`
            : ''

        const notDraft = ''
        // details?.userrole === 'qcreator' ||
        // details?.userrole === 'qapprover' ||
        // details?.userrole === 'qreviewer' ||
        // details?.userrole === 'variantcreator'
        //   ? 'status:{_neq:"Draft"}'
        //   : ''
        const workRequestTypeFilter =
          details?.userrole === 'qcreator' ? 'request_type: {_eq:"Q"}' : details?.userrole === 'variantcreator' ? 'request_type:{_eq:"V"}' : ''

        const QUERY = gql`
          query getCountFromList {
            openWorkRequestCount: work_requests_aggregate(where: { active:{ _eq: "true"}, ${roleWiseFilter}, ${notDraft}, ${workRequestTypeFilter}, status: { _eq: "Open" }}){
              aggregate{
                count
              }
            }
            closedWorkRequestCount: work_requests_aggregate(where: { active:{ _eq: "true"}, ${roleWiseFilter}, ${notDraft}, ${workRequestTypeFilter},  status: { _eq: "Closed" }}){
              aggregate{
                count
              }
            }
            inProgressWorkRequestCount: work_requests_aggregate(where: { active:{ _eq: "true"}, ${roleWiseFilter}, ${notDraft}, ${workRequestTypeFilter},  status: { _eq: "In Progress" }}){
              aggregate{
                count
              }
            }
            draftWorkRequestCount: work_requests_aggregate(where: { active:{ _eq: "true"}, ${roleWiseFilter}, ${notDraft}, ${workRequestTypeFilter},  status: { _eq: "Draft" }}){
              aggregate{
                count
              }
            }
          }
          `
        return QUERY
      } else if (details?.resource === 'uploaded_question') {
        const roleWiseFilter =
          details?.userrole === 'qcreator' || details?.userrole === 'variantcreator' ? `creator_id: {_eq:"${details.userId}"}` : ''
        const requestType = 'request_type: {_eq:"Uploaded"}'
        const QUERY = gql`
          query getCountFromlist {
            forApprovalCount: questions_aggregate(where: {active: {_eq:"true"}, ${requestType}, ${roleWiseFilter}, status:{_eq:"For Approval"}}){
              aggregate{
                count
              }
            }
            publishedCount: questions_aggregate(where: {active: {_eq:"true"},  ${requestType},  ${roleWiseFilter},  status:{_eq:"Published"}}){
              aggregate{
                count
              }
            }
            rejectedAtApprovalCount: questions_aggregate(where: {active: {_eq:"true"}, ${requestType},  ${roleWiseFilter},  status:{_eq:"Rejected at Approval"}}){
              aggregate{
                count
              }
            }
            requireAmendingCount: questions_aggregate(where: {active: {_eq:"true"}, ${requestType}, ${roleWiseFilter},  status:{_eq:"For Review (Require Amending)"}}){
              aggregate{
                count
              }
            }
            forReviewCount: questions_aggregate(where: {active: {_eq:"true"},  ${requestType}, ${roleWiseFilter},  status:{_eq:"For Review"}}){
              aggregate{
                count
              }
            }
            openRequireAmendingCount: questions_aggregate(where: {active: {_eq:"true"},  ${requestType}, ${roleWiseFilter},  status:{_eq:"Open (Require Amending)"}}){
              aggregate{
                count
              }
            }
            openCount: questions_aggregate(where: {active: {_eq:"true"}, ${requestType}, ${roleWiseFilter}, status:{_eq:"Open"}}){
              aggregate{
                count
              }
            }
            rejectedAtReviewCount: questions_aggregate(where: {active: {_eq:"true"},  ${requestType}, ${roleWiseFilter}, status:{_eq:"Rejected at Review"}}){
              aggregate{
                count
              }
            }
            secondReviewCount: questions_aggregate(where: {active: {_eq:"true"},  ${requestType}, ${roleWiseFilter},  status:{_eq:"For Second Review"}}){
              aggregate{
                count
              }
            }
            retriedCount: questions_aggregate(where: {active: {_eq:"true"},  ${requestType}, ${roleWiseFilter},  status:{_eq:"Retired"}}){
              aggregate{
                count
              }
            }
            secondApprovalCount: questions_aggregate(where: {active: {_eq:"true"},  ${requestType}, ${roleWiseFilter},  status:{_eq:"For Second Approval"}}){
              aggregate{
                count
              }
            }
            
          }
          `
        return QUERY
      } else if (details?.resource === 'draft_questions') {
        const QUERY = gql`
          query getCountFromlist {
            forTotalCount: questions_aggregate(where: { status: { _eq: "Draft" } }) {
              aggregate {
                count
              }
            }
          }
        `
        return QUERY
      }
    }
    const QUERY = await findCountQuery(details)

    const { data, error } = await nhost.graphql.request(QUERY ? QUERY : '')
    if (error) {
      console.log(error, 'error')
    }
    return data
  } catch (err) {
    console.log(err, ':error on get count query')
  }
}
///

export const getAllDistinctCustomTags = async () => {
  try {
    const QUERY = gql`
      query getAllDistinctCustomTags {
        questions(distinct_on: custom_tag) {
          custom_tag
        }
      }
    `
    const { error, data } = await nhost.graphql.request(QUERY)
    if (data) {
      return data
    } else {
      return { status: false }
    }
  } catch (err) {
    console.log(err, 'error while finding all distinct custom tags')
  }
}

export const getQuestionsWithFilters = async (filters: any) => {
  try {
    const conditions = [
      `active:{_eq:"true"}`,
      `qb_permit:{_eq:true}`,
      `status:{_neq:"Retired"}`,
      filters.topicId ? `topic_id: {_eq: "${filters.topicId}"}` : '',
      filters.bloomLevelId ? `bloom_level_id:{_eq:"${filters.bloomLevelId}"}` : '',
      filters.difficultyLevelId ? `difficulty_level_id:{_eq:"${filters.difficultyLevelId}"}` : '',
      filters.subThemeId ? `sub_theme_id: {_eq: "${filters.subThemeId}"}` : '',
      filters.themeId ? `theme_id: {_eq: "${filters.themeId}"}` : '',
      // filters.reportThemeId ? `report_theme_id: {_eq: "${filters.reportThemeId}"}` : '',
      filters.subjectId ? `subject_id: {_eq: "${filters.subjectId}"}` : '',
      filters.subSectionQuestionType ? `question_type_id: {_eq: "${filters.subSectionQuestionType}"}` : '',
      filters.competencyId ? `competency_id:{_eq:"${filters.competencyId}"}` : '',
      filters.strandId ? `strand_id:{_eq:"${filters.strandId}"}` : '',
      filters.gradeIds.length > 0 ? `grade_ids: {_has_keys_any: ["${filters.gradeIds.join('","')}"]}` : '',
      `option_details: {_is_null: false}`,
      filters.assignedQuestions.length > 0 ? `id:{_nin:["${filters.assignedQuestions.join('","')}"]}` : '',
      filters.variant_questions.length > 0 ? `question_id:{_nin:["${filters.variant_questions.join('","')}"]}` : '',
      filters?.transilaton_lang
        ? `language:{_ilike:"${filters?.transilaton_lang}"},transilation_of:{_is_null:false}`
        : filters?.base_lang
        ? `language:{_ilike:"${filters?.base_lang}"},transilation_of:{_is_null:true}`
        : 'transilation_of:{_is_null:true}',
    ]
    const QUERY = gql`
      query getQuestionsWithFilters {
        questions(where: { _and: {${conditions.join(', ')},} }){
        id,
        title,
        question_id
        request_type
        status
        option_details
        question_type_id
        language
        transilation_of
        variant_of
        }
      }
    `
    const { error, data } = await nhost.graphql.request(QUERY)
    if (data) {
      return data
    } else {
      console.log(error, 'error is this')
      return { status: false, error: true }
    }
  } catch (err) {
    console.log(err)
  }
}

export const getAllFlaggedQuestions = async () => {
  try {
    const QUERY = gql`
      query getAllFlaggedQuestions {
        flagged_questions {
          question_id
        }
      }
    `
    const { error, data } = await nhost.graphql.request(QUERY)
    if (data) {
      return data
    } else {
      return []
    }
  } catch (err) {
    console.log(err, 'error from flagged questions')
    return []
  }
}

export const getCleanUpQuestions = async () => {
  try {
    const QUERY = gql`
      query getAllCleanUpQuestions {
        cleanup_window_questions {
          question_id
        }
      }
    `
    const { error, data } = await nhost.graphql.request(QUERY)
    if (data) {
      return data
    } else {
      return []
    }
  } catch (err) {
    console.log(err, 'error from clean up question query')
    return []
  }
}

export const getAiDetails = async (models: boolean, limit: boolean) => {
  try {
    let QUERY = ''
    if (models) {
      QUERY = gql`
        query getAllAiModelList {
          ai_models {
            id
            model_name
            in_use
          }
        }
      `
    } else if (limit) {
      QUERY = gql`
        query getAllAiLimit {
          ai_limit {
            id
            limit
            in_use
          }
        }
      `
    }

    const { error, data } = await nhost.graphql.request(QUERY)
    return data
  } catch (err) {
    console.log(err, 'error while fetching all ai models')
    return []
  }
}

// Query to fetch the Limit
export const getLimitWhereInUse = async () => {
  const QUERY = gql`
    query getLimitWhereInUse {
      ai_limit(where: { in_use: { _eq: true } }) {
        limit
      }
    }
  `

  try {
    const { error, data } = await nhost.graphql.request(QUERY)
    return data
  } catch (error) {
    console.error('Error fetching limits:', error)
    throw error // Optional: Rethrow the error to handle it further up the call stack
  }
}

export const getReportThemeDetailsFromTopic = async (topicId: string) => {
  try {
    const QUERY = gql`
    query getReportThemeDetails{
    report_themes(where:{theme_ids:{_contains:["${topicId}"]}}){
    id
    name
    }
    }
    `
    const { data } = await nhost.graphql.request(QUERY)
    return data
  } catch (err) {
    console.log(err)
    return null
  }
}

export const findProjectFieldName = async (value: string, field: string, tableName: string) => {
  const reportThemeIds = tableName === 'project_config' ? 'report_theme_ids' : ``
  const in_use_validation = tableName !== 'subjects' && tableName !== 'report_themes' ? `in_use: { _eq: true },` : ``
  try {
    const QUERY = gql`
query getProjectDetails{
${tableName}(where:{${in_use_validation} ${field}:{_eq:"${value}"}}){
id,
name,
${reportThemeIds}
}
}
`
    const { data, error } = await nhost.graphql.request(QUERY)
    return data
  } catch (err) {
    console.log(err)
    return null
  }
}

export const findAlreadyAssignPaperForTestEvent = async (testEventId: any) => {
  try {
    const QUERY = gql`
    query getAlreadyAssignedPaper{
    test_event_assigned_papers(where:{test_event_id:{ _eq: "${testEventId}" }}){
    id,
    paper_id,
    slot_assigned,
    paper{
    id,
    paper_id,
    paper_smart_id,
    sections,
    status,
    } 
    }
    }
    `
    const { data, error } = await nhost.graphql.request(QUERY)
    return data
  } catch (err) {
    return null
  }
}

export const findEvaluationRequestOfAssignedPaper = async (paperId: string, testEventId: string) => {
  try {
    const QUERY = gql`
query getEvaluationRequestDetails{
evaluation_requests(where:{
_and:[{test_event_id:{_eq:"${testEventId}"}},{paper_id:{_eq:"${paperId}"}}]}){
id
created_at
name
evaluations{
id
name
}
}
}
`
    const { data } = await nhost.graphql.request(QUERY)
    return data
  } catch (err) {
    return null
  }
}

export const getDetailsById = async (id: string | null, table: string, fieldName: string, entities: string) => {
  try {
    const whereClause = id ? `(where: { ${fieldName}: { _eq: "${id}" } })` : ''
    const QUERY = gql`
    query getDetailsById {
      ${table} ${whereClause} ${entities}
    }
  `
    const response: any = await nhost.graphql.request(QUERY)
    if (response?.data) {
      return response?.data[table]
    }
    return []
  } catch (err) {
    console.log(err, 'ERROR')
    return []
  }
}

export const getMultipleItemDetailsById = async (
  tableName: string,
  values: any[],
  fieldName: string,
  entities: string,
  typeName: 'uuid' | 'Int' | 'String' = 'uuid'
) => {
  try {
    const QUERY = `
      query getMultipleItems($ids: [${typeName}!]!) {
        ${tableName}(where: { ${fieldName}: { _in: $ids } }){
         ${entities}
        }
      }
    `
    const { data, error }: any = await nhost.graphql.request(QUERY, { ids: values })
    return data[tableName]
  } catch (err) {
    console.log(err)
    return null
  }
}